export default "ECS solaire collective (fiche CEE BAT-TH-152) pour bâtiments à fort besoin d'ECS : hôtellerie, restauration collective, EHPAD, équipements sportifs. Cumulable Fonds chaleur ADEME.";
